import "./TeacherBlock.css";
import avatar from "../../../image/avatar.webp";
import { Link } from "react-router-dom";

function TeacherBlock() {
  return (
    <section className="teacher" id="teacher">
      <div className="teacher__container">
        <div className="teacher__media">
          <div className="teacher__image-wrap">
            <img
              className="teacher__image"
              src={avatar}
              alt="Преподаватель курса Евгений"
            />
          </div>
          <div className="teacher__stats" aria-label="Краткая информация о преподавателе">
            <p className="teacher__stat">
              <span className="teacher__stat-value">13+ лет</span>
              <span className="teacher__stat-label">в мебельной сфере</span>
            </p>
            <p className="teacher__stat">
              <span className="teacher__stat-value">500+</span>
              <span className="teacher__stat-label">реальных проектов</span>
            </p>
          </div>
        </div>

        <div className="teacher__content">
          <p className="teacher__label">О преподавателе</p>

          <h2 className="teacher__title">
            Вас будет обучать практикующий конструктор-технолог мебели
          </h2>

          <p className="teacher__text">
            Меня зовут Евгений. Более 13 лет я проектирую корпусную мебель и
            работаю с реальными задачами производства.
          </p>

          <p className="teacher__text">
            Внедрял систему БАЗИС в рабочие процессы и руководил
            конструкторско-технологическим отделом.
          </p>

          <ul className="teacher__list">
            <li className="teacher__item">Более 13 лет в мебельной сфере</li>
            <li className="teacher__item">Эксперт по системе БАЗИС</li>
            <li className="teacher__item">
              Практический опыт работы с производством
            </li>
            <li className="teacher__item">
              Опыт руководства конструкторско-технологическим отделом
            </li>
            <li className="teacher__item">
              Обучение без перегруза, от простого к сложному
            </li>
          </ul>

          <p className="teacher__note">
            Моя задача — не просто показать программу, а научить вас делать
            проекты, которые можно реально запускать в производство.
          </p>

          <div className="teacher__actions">
            <Link className="teacher__portfolio-link" to="/portfolio">
              Смотреть портфолио преподавателя
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TeacherBlock;
